import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SnackBarService } from '../../../services/snack-bar.service';
import { UsersService } from '../services/users.service';
import labels from './../data/add-user.json';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrl: './add-user.component.scss',
})
export class AddUserComponent {
  header: string = labels.header;
  hasAceessLabel: string = labels.hasAccess;
  loading = false;

  // `hasAccess` must NOT have Validators.required — it's a boolean where
  // `false` is a legitimate choice (member not on the va'ad). The former
  // `Validators.required` treated `false` as invalid and permanently
  // disabled the submit button, making it impossible to add regular
  // (non-admin) users. `password` minLength is 4 to match the server's
  // zod schema; the previous value of 1 let the client submit strings
  // that the server always rejected.

  addUserForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(4),
      Validators.maxLength(20),
    ]),
    firstName: new FormControl('', [
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(15),
    ]),
    lastName: new FormControl('', [
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(20),
    ]),
    hasAccess: new FormControl(false),
  });

  constructor(
    private userService: UsersService,
    private snackBar: SnackBarService,
  ) {}

  async onSubmit(): Promise<void> {
    if (this.addUserForm.invalid || this.loading) return;
    this.loading = true;
    try {
      const value = this.addUserForm.value;
      await this.userService.addUser(value);
      this.snackBar.openToast('משתמש נוסף בהצלחה', {
        kind: 'success',
        description: `${value.firstName} ${value.lastName}`,
      });
      this.addUserForm.reset({
        email: '',
        password: '',
        firstName: '',
        lastName: '',
        hasAccess: false,
      });
    } catch (err) {
      console.error(err);
      this.snackBar.openToast('לא ניתן להוסיף משתמש', {
        kind: 'error',
        description: 'בדוק שכתובת האימייל תקינה ושהסיסמה בת 4 תווים לפחות.',
      });
    } finally {
      this.loading = false;
    }
  }
}
